import { render, staticRenderFns } from "./MediaSettings.vue?vue&type=template&id=3043e78d&scoped=true"
import script from "./MediaSettings.vue?vue&type=script&lang=ts"
export * from "./MediaSettings.vue?vue&type=script&lang=ts"
import style0 from "./MediaSettings.vue?vue&type=style&index=0&id=3043e78d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3043e78d",
  null
  
)

export default component.exports